import { getConfig } from './config';

export const openNotification = ({
  message,
  type,
}: {
  message: string;
  type: any;
}) => {
  console.log(message, type);
};

export const isDevelop = () => {
  if (typeof window !== 'undefined') {
    return ['localhost', '127.0.0.1', '0.0.0.0'].includes(
      window.location.hostname
    );
  } else {
    return getConfig().environment === 'development';
  }
};
